import React from 'react';
import { TextLink } from '../../components/sections/TextLink';

export const UniverseLinks = () => (
  <section className="container-custom py-24 md:py-32 flex flex-col sm:flex-row gap-10 sm:gap-16">
    <TextLink to="/devis" testId="universe-cta-devis">Demander un devis</TextLink>
    <TextLink to="/#univers" testId="universe-back">Les trois univers</TextLink>
  </section>
);
